import {
  Heading,
  Link as JaimyLink,
  List,
  ListItem,
  OrderedList,
  Text,
} from '@brand/components';
import { theme } from '@brand/theme/theme';
import { FaCheckCircle } from 'react-icons/fa';
import { PrismicRichText as RichText } from '@prismicio/react';
import * as prismicT from '@prismicio/types';

interface Props {
  render?: prismicT.RichTextField;
  color?: string;
}

export const PrismicRichText = (props: Props): JSX.Element => {
  const { color = theme.colors.secondary } = props; // Assign a default color if not provided

  return (
    <RichText
      field={props.render}
      components={{
        heading1: ({ children }) => (
          <Heading variant="h1" mb={2} color={color}>
            {children}
          </Heading>
        ),
        heading2: ({ children }) => (
          <Heading variant="h2" color={color}>
            {children}
          </Heading>
        ),
        heading3: ({ children }) => (
          <Heading variant="h3" mb={2} color={color}>
            {children}
          </Heading>
        ),
        heading4: ({ children }) => (
          <Heading variant="h4" mb={2} color={color}>
            {children}
          </Heading>
        ),
        heading5: ({ children }) => (
          <Heading variant="h5" mb={2} color={color}>
            {children}
          </Heading>
        ),
        heading6: ({ children }) => (
          <Heading variant="h6" mb={2} color={color}>
            {children}
          </Heading>
        ),
        paragraph: ({ children }) => (
          <Text mb={8} color={color} textAlign="justify">
            {children}
          </Text>
        ),
        strong: ({ children }) => (
          <strong style={{ color: color }}>{children}</strong>
        ),
        em: ({ children }) => <em style={{ color: color }}>{children}</em>,
        list: ({ children }) => (
          <List spacing={4} mb={4} color={color}>
            {children}
          </List>
        ),
        listItem: ({ children }) => (
          <ListItem gap={4} color={color}>
            <span style={{ marginRight: '5px' }}>
              <FaCheckCircle color={color} />
            </span>
            <div>{children}</div>
          </ListItem>
        ),
        oList: ({ children }) => (
          <OrderedList color={color}>{children}</OrderedList>
        ),
        oListItem: ({ children }) => (
          <ListItem fontWeight="medium" display="list-item" color={color}>
            <span style={{ marginRight: '5px' }}>
              <FaCheckCircle color={color} />
            </span>
            {children}
          </ListItem>
        ),
        hyperlink: ({ node, children }) => {
          if (node.data.link_type === 'Web') {
            return (
              <JaimyLink
                href={node.data.url}
                target={node.data.target}
                color="primary.base"
              >
                {children}
              </JaimyLink>
            );
          } else {
            return (
              <JaimyLink
                href={node.data.url}
                // target={node.data.target}
                color="primary.base"
              >
                {children}
              </JaimyLink>
            );
          }
        },
      }}
    />
  );
};
